import { SILD8X100_SKU, SILD8X50_SKU } from "./product-skus";

export const mutuallyExclusiveProducts = {
  [SILD8X50_SKU]: SILD8X100_SKU,
  [SILD8X100_SKU]: SILD8X50_SKU,
};
